import axios from "./axios";
import baseUrl from "../../environment";

class SearchService {
    esSearch(query, location, locationString) {
        const url = baseUrl + '/search';
        const options = {
            method: 'POST',
            headers: { 
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            data: query,
            url
        };
        return axios(options);
        // return axios.post(baseUrl + '/search', query);
    }

    esSearchSuggest(query, location, locationString) {
        const url = baseUrl + '/suggest';
        const options = {
            method: 'POST',
            headers: { 
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            data: query,
            url
        };
        return axios(options);
        // return axios.post(baseUrl + '/suggest', query);
    }

    esSearchWithAuth(query, location, locationString) {
        const url = baseUrl + '/auth/search';
        const options = {
            method: 'POST',
            withCredentials: true,
            headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            data: query,
            url
        };
        return axios(options);
        // return axios({
        //     url: baseUrl + '/auth/search',
        //     method: "post",
        //     withCredentials: true,
        //     headers: {
        //         'Accept': 'application/json',
        //         'Content-Type': 'application/json'
        //     },
        //     data: query
        // });
    }

    esSearchSuggestWithAuth(query, location, locationString) {
        const url = baseUrl + '/auth/suggest';
        const options = {
            method: 'POST',
            withCredentials: true,
            headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            data: query,
            url
        };
        return axios(options);
        // return axios({
        //     url: baseUrl + '/auth/suggest',
        //     method: "post",
        //     withCredentials: true,
        //     headers: {
        //         'Accept': 'application/json',
        //         'Content-Type': 'application/json'
        //     },
        //     data: query
        // });
    }

    esAdvancedSearch(query, location, locationString) {
        const url = baseUrl + '/auth/adv_search';
        const options = {
            method: 'POST',
            withCredentials: true,
            headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Curr-Loc': location, 
                'CMode': locationString
            },
            data: query,
            url
        };
        return axios(options);
        // return axios({
        //     url: baseUrl + '/auth/adv_search',
        //     method: "post",
        //     withCredentials: true,
        //     headers: {
        //         'Accept': 'application/json',
        //         'Content-Type': 'application/json'
        //     },
        //     data: query
        // });
    }
}

export default SearchService;